exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "[data-v-1a6c4846] .el-dialog__body {\n  padding-top: 0;\n}\n[data-v-1a6c4846] .el-dialog__header {\n  font-weight: bold;\n}\n.flex[data-v-1a6c4846] {\n  display: flex;\n  align-items: center;\n  color: #262626;\n  font-size: 0.072917rem;\n  font-weight: bold;\n}", ""]);

// exports
